import script from "./TreasuryShares.vue?vue&type=script&setup=true&lang=js"
export * from "./TreasuryShares.vue?vue&type=script&setup=true&lang=js"

import "./TreasuryShares.vue?vue&type=style&index=0&id=3298c2e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3298c2e4"]])

export default __exports__